import { render, staticRenderFns } from "./label.vue?vue&type=template&id=61d82d9c&scoped=true&"
import script from "./label.vue?vue&type=script&lang=ts&"
export * from "./label.vue?vue&type=script&lang=ts&"
import style0 from "./label.vue?vue&type=style&index=0&id=61d82d9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d82d9c",
  null
  
)

export default component.exports